import firebase from 'firebase/app';

export class Timestamp extends firebase.firestore.Timestamp {}

export class DateRange {
  start: Timestamp;
  end: Timestamp;
}
